"use strict";function callComponent$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.callComponent$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.callComponent";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.3.35"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.3.35"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"6.3.35"},_a)),exports.callComponent$=callComponent$,exports.default=callComponent$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@3.0.14@dingtalk-jsapi/api/biz/util/callComponent.js
// module id = 1128
// module chunks = 106